export default __webpack_public_path__ + "static/1892-dd1afbdd0c2b3257e4c890db7d1fcd11.gif";